import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * Vive dentro del grupo `_contabilidad`, asi que el guardian ya se aplico y esta ruta no repite
 * ninguna verificacion.
 *
 * El componente llega a pedido, como los otros dos que ya lo hacen y por la misma razon: arrastra
 * `@tanstack/query` y las cuatro piezas del modulo, y el operario no debe descargar nada de eso.
 * Adjudicacion 41.
 */
export const rutaCobros = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/cobros',
  component: lazyRouteComponent(() => import('./cobros-pantalla.js'), 'RutaCobros'),
});
